import { Routes, Route, NavLink } from 'react-router-dom';
import SettingsUsers from './settings/SettingsUsers';
import SettingsRoles from './settings/SettingsRoles';
import SettingsIntegrations from './settings/SettingsIntegrations';
import SettingsOperatingHours from './settings/SettingsOperatingHours';
import SettingsStatusIcons from './settings/SettingsStatusIcons';
import SettingsCampaigns from './settings/SettingsCampaigns';
import SettingsAgents from './settings/SettingsAgents';
import SettingsLogging from './settings/SettingsLogging';
import SettingsWebhooks from './settings/SettingsWebhooks';

const tabs = [
  { path: 'users', label: 'Users' },
  { path: 'roles', label: 'Roles and Permissions' },
  { path: 'integrations', label: 'Integrations' },
  { path: 'campaigns', label: 'Campaigns' },
  { path: 'agents', label: 'Agents' },
  { path: 'email', label: 'Email' },
  { path: 'notifications', label: 'Notifications' },
  { path: 'operating-hours', label: 'Operating hours' },
  { path: 'status-icons', label: 'Status icons' },
  { path: 'logging', label: 'Logging' },
  { path: 'webhooks', label: 'Webhooks' },
];

export default function Settings() {
  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0, overflow: 'hidden' }}>
      <h1 style={{ marginTop: 0 }}>Settings</h1>
      <div style={{ display: 'flex', gap: '2rem', flex: 1, minHeight: 0, alignItems: 'stretch' }}>
        <nav style={{ flex: '0 0 200px' }}>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
            {tabs.map(({ path, label }) => (
              <li key={path}>
                <NavLink
                  to={path}
                  end={path === 'users'}
                  style={({ isActive }) => ({
                    display: 'block',
                    padding: '0.5rem 0',
                    color: isActive ? 'var(--accent)' : 'var(--text-muted)',
                    textDecoration: 'none',
                  })}
                >
                  {label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
        <div style={{ flex: 1, minWidth: 0, minHeight: 0, display: 'flex', flexDirection: 'column', overflowY: 'auto' }}>
          <Routes>
            <Route index element={<SettingsUsers />} />
            <Route path="users" element={<SettingsUsers />} />
            <Route path="roles" element={<SettingsRoles />} />
            <Route path="integrations" element={<SettingsIntegrations />} />
            <Route path="campaigns" element={<SettingsCampaigns />} />
            <Route path="agents" element={<SettingsAgents />} />
            <Route path="email" element={<PlaceholderTab name="Email" />} />
            <Route path="notifications" element={<PlaceholderTab name="Notifications" />} />
            <Route path="operating-hours" element={<SettingsOperatingHours />} />
            <Route path="status-icons" element={<SettingsStatusIcons />} />
            <Route path="logging" element={<SettingsLogging />} />
            <Route path="webhooks" element={<SettingsWebhooks />} />
          </Routes>
        </div>
      </div>
    </div>
  );
}

function PlaceholderTab({ name }: { name: string }) {
  return <p style={{ color: 'var(--text-muted)' }}>Tab: {name} — coming soon.</p>;
}
